/**
 * Points configuration — the values the model runs on. Deliberately not
 * persisted and not editable: an earlier version saved to localStorage, and once
 * the business settled the supplement basis, stale saves silently overrode the
 * agreed values with no UI to reset them. A context rather than a direct import,
 * so only this file changes when the values move to the API.
 */
import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { DEFAULT_POINTS_CONFIG } from "./points";
import type { PointsConfig } from "./points";

const PointsConfigContext = createContext<{ config: PointsConfig }>({ config: DEFAULT_POINTS_CONFIG });

export const PointsConfigProvider = ({ children }: { children: ReactNode }) => (
    <PointsConfigContext.Provider value={{ config: DEFAULT_POINTS_CONFIG }}>{children}</PointsConfigContext.Provider>
);

export const usePointsConfig = () => useContext(PointsConfigContext);
